export default __webpack_public_path__ + "static/media/chumbo-vertical-mobile.16e8d2de.png";